module.exports = __webpack_public_path__ + "assets/coupon.2fa2a37e.svg";